import { z } from "zod";

export const EmulatorEndpoints = z.strictObject({
	host: z.enum(["127.0.0.1", "localhost", "::1"]),
	auth: z.number().int().min(1).max(65535),
	firestore: z.number().int().min(1).max(65535),
	storage: z.number().int().min(1).max(65535),
	functions: z.number().int().min(1).max(65535),
});
export type EmulatorEndpoints = z.infer<typeof EmulatorEndpoints>;
